<div plyr plyrTitle="Video" [plyrPlaysInline]="true" [plyrSources]="videoSources" [plyrOptions]="plyrOptions"
  (plyrPlay)="onPlayed($event)" (plyrInit)="onInit($event)" (plyrEnded)="onEnded($event)" (plyrPause)="onPause($event)"
  (plyrPlaying)="onPlaying($event)" (plyrProgress)="onProgress($event)" (plyrCanPlayThrough)="onCanPlay($event)"
  (plyrCrossOrigin)="true"></div>

<!-- <div plyr plyrTitle="Video" [plyrPlaysInline]="true" [plyrSources]="videoSources" [plyrOptions]="plyrOptions"
  (plyrStateChange)="onStageChange($event)" (plyrInit)="onInit($event)"></div> -->